
import Vue from 'vue';
export default {
    scrollToTop: true,
    head() {
        return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Ballaleshwar Ganpati Temple Pali" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Ballaleshwar Ganpati Temple Pali" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Ballaleshwar Temple, Ashtavinayak Ganpati Pali, Ballaleshwar Ganpati Pali, Ashtavinayak Yatra, Pali Ganpati Temple, Ballaleshwar Ganesh Maharashtra, Ashtavinayak Pilgrimage, Ballaleshwar Vinayak Temple, Ashtavinayak Darshan'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Ballaleshwar Temple, Ashtavinayak Ganpati Pali, Ballaleshwar Ganpati Pali, Ashtavinayak Yatra, Pali Ganpati Temple, Ballaleshwar Ganesh Maharashtra, Ashtavinayak Pilgrimage, Ballaleshwar Vinayak Temple, Ashtavinayak Darshan, Ashtavinayak, ballaleshwar pali temple timings, pali ganpati temple address, ballaleshwar pali directions, pali ganpati temple contact number, Ballaleshwar Pali' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/ballaleshwar.webp'
          },
          {
            hid: 'og:image', 
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/ballaleshwar.webp'
          },
        ],
    }

},

    components: {
    },
    data() {
        return {
            title: 'Shree Ballaleshwar Ganpati Temple Pali | Ashtavinayak - श्री बल्लाळेश्वर मंदिर पाली(अष्टविनायक)',
            langauageMarathi: true
        }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/ballaleshwar"
        },
        "headline": "Shree Ballaleshwar Ganpati Temple Pali - श्री बल्लाळेश्वर मंदिर पाली(अष्टविनायक)",
        "name" : "Shree Ballaleshwar Ganpati Temple Pali - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Ballaleshwar Ganpati Temple Pali' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/ballaleshwar.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    computed: {

    },
    methods: {
        changeLanguage: function () {
            this.langauageMarathi = !this.langauageMarathi
        }
    }

}
